import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    width: '100%',
    minHeight: theme.spacing(6),
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
    textAlign: 'left',

    '& .marker': {
      minWidth: theme.spacing(4),
      marginRight: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      '&-circle': {
        width: `${theme.spacing(1) - 1}px`,
        height: `${theme.spacing(1) - 1}px`,
        borderRadius: '50%',
        border: 'solid 1px',
        backgroundColor: theme.palette.custom.background.area,
        position: 'relative',
        zIndex: 1,
      },
      '&-line': {
        position: 'absolute',
        zIndex: 0,
        width: 1,
        backgroundColor: theme.palette.divider,
        top: props => (props.first ? '50%' : 0),
        bottom: props => (props.last ? '50%' : 0),
      },
    },

    '& .title': {
      flexGrow: 1,
      fontWeight: props =>
        props.module
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightBold,
    },

    '&:hover': {
      backgroundColor: theme.palette.custom.surface[1],
    },
    '&.resting': {
      color: theme.palette.text.secondary,
    },
    '&.locked': {
      color: theme.palette.text.hint,
    },
    '&.completed': {
      '&, & .icon': {
        color: theme.palette.custom.feedback.positive,
      },
      '& .title': {
        textDecoration: 'line-through',
      },
    },
    '&.active': {
      backgroundColor: theme.palette.custom.surface[1],
      color: theme.palette.primary.main,
      '& .title-text': {
        fontWeight: theme.typography.fontWeightBold,
      },
    },
  },
}));

export default styles;
